export interface SalesDespatchItemInvoiceDetail {
  id: string;
  stockNo: string;
  orderNo: string;
  productKey: string;
  productDescription: string;
  invoicePrice: number;
  freeOfChargeQty: number;
  grossQuantity: number;
  nettQuantity: number;
  despatchNoteNo: number;
  despatchDate: Date;
  selected: boolean;
}
